export const TRAINING_CLASSIFICATION = {
     COURSE_UPCOMING: '{genericPublicName} Events',
     COURSE_PAST: 'Your Past {genericPublicName}',
     COURSE_PAST_NOT_COMPLETE: 'Past {genericPublicName} Not Yet Complete',
     COURSE_PAST_WITH_CE: 'Past {genericPublicName} with CE Opportunities',
     COURSE_COMPLETED: 'View Your Completed {genericPublicName}',
     PRODUCT_NOT_PURCHASE: 'Purchase Upcoming {genericPublicName}',
};

export const PRODUCT_TYPES = {
     THE_BOOK_AND_SSF4: 'The Book & SSF-4',
     ONLINE_COURSES_AND_CES: 'Online Courses & CEs',
     ROLE_PLAY_TRAININGS: 'Role Play Trainings',
     CONSULTATION_CALLS: 'Consultation Calls',
     TRAINING_DAYS: 'Training Days',
};

export const TRAINING_PRODUCT_TYPES = {
     PHYSICAL_PRODUCT: 'Physical Product',
     PURCHASE_DIGITAL_DOWNLOAD: 'Purchase Digital Download',
     DIGITAL_DOWNLOAD: 'Digital Download',
     ONLINE_COURSE: 'Online Course',
     TEST_ONLY: 'Test Only',
     SURVEY_ONLY: 'Survey Only',
     LIVE_TRAINING: 'Live Training',
     CE_CREDITS: 'CE Credits (no test)',
     BUNDLE: 'Bundle',
};

export const USER_PRODUCT_CREATE_BY = {
     SYSTEM: 'system',
     ADMIN: 'admin',
     SUBSCRIBER: 'subscriber',
};

export const ORG_PRODUCT_CREATE_BY = {
     SYSTEM: 'system',
     ADMIN: 'admin',
     SUBSCRIBER: 'subscriber',
};

export const SEAT_CREATE_BY = {
     SYSTEM: 'system',
     ADMIN: 'admin',
     SUBSCRIBER: 'subscriber',
};

export const PRODUCT_TYPES_REQUIRE_EVENT = [TRAINING_PRODUCT_TYPES.LIVE_TRAINING];

export const PURCHASE_TYPES = {
     ORGANIZATION: 'organization',
     INDIVIDUAL: 'individual',
     INVISIBLE: 'invisible',
     BOTH: 'both',
};

export const TRAINING_TYPES = {
     ROLE_PLAY: 'role-play',
     CALL: 'call',
};

export const PRODUCT_TYPES_NOT_SET_MAIN_TEST = [
     'Physical Product',
     'Purchase Digital Download',
     'Digital Download',
     'Live Training',
     'Group Live Training',
];

export const PRODUCT_TYPES_SET_TRAINING_EVENT = ['Live Training', 'Group Live Training'];
